import { CurrencyPair } from '@models/next/Money';
import { f } from '@utils/nextForms';
import { z } from 'zod';

export const CurrencyRate = z.object({
  pair: z.enum(['JPY_USD']),
  date: f.dateString(),
  rate: z.coerce.number(),
  fetch_time: z.string(),
  update_time: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export interface CurrencyRate extends z.infer<typeof CurrencyRate> {}

export const ExchangeCalendarQuery = z.object({
  pair: CurrencyPair,
  start: f.dateString(),
  end: f.dateString(),
});

export type ExchangeCalendarQuery = z.infer<typeof ExchangeCalendarQuery>;

export const PostCurrencyRate = z.object({
  pair: CurrencyRate.shape.pair,
  date: CurrencyRate.shape.date,
  rate: CurrencyRate.shape.rate,
  fetch_time: CurrencyRate.shape.fetch_time,
  update_time: CurrencyRate.shape.update_time,
});

export type PostCurrencyRate = z.infer<typeof PostCurrencyRate>;
